const navigationNames = {
  home: {
    id: "home",
    title: "Juta",
  },
  docs: { id: "docs", title: "Docs" },
  about: { id: "about", title: "About" },
  termsOfService: { id: "termsOfService", title: "Terms of Service" },
  privacyPolicy: { id: "privacyPolicy", title: "Privacy Policy" },
};

export default navigationNames;
